import BaseEventModel from '../events/base-event-model';
import { expect } from '../expect';
import { IEventSender } from './event-sender';
import { TrackingPixelEventParamsMapper } from './tracking-pixel';
import { IHttp } from '../http';

export class GetRequestEventSender implements IEventSender {
  private readonly cdn: string;
  private readonly http: IHttp;

  /** Initializes a new instance of the ShopifyFetchEventSender class. */
  constructor(cdn: string, http: IHttp) {
    this.cdn = expect(cdn).toBeDefined('The CDN is required to initialize ShopifyFetchEventSender.');
    this.http = expect(http).toBeDefined('The IHttp implementation is required to initialize ShopifyFetchEventSender');
  }

  /** Sends event to the provided CDN using Tracking Pixel. */
  public send(event: BaseEventModel): Promise<void> {
    const url = new URL('/client', this.cdn);
    for (const fieldName in event) {
      let value = event[fieldName];
      if (value === null || value === undefined) {
        continue;
      }
      if (value && typeof value === 'object') {
        value = JSON.stringify(value);
      }
      url.searchParams.append(TrackingPixelEventParamsMapper.map(fieldName), value);
    }

    return this.http.get(url.toString());
  }
}
